"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _TimelineMonthLabel = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineMonthLabel"));

function TimelineMonth(_ref) {
  var text = _ref.text,
      label = _ref.label,
      _ref$isFirstMonth = _ref.isFirstMonth,
      isFirstMonth = _ref$isFirstMonth === void 0 ? false : _ref$isFirstMonth;
  var labelClasses = (0, _classnames.default)('m-bottom-0', {
    'm-top-4': isFirstMonth,
    'm-top-0': !isFirstMonth
  });
  return _react.default.createElement("div", {
    className: "p-bottom-2"
  }, _react.default.createElement(_TimelineMonthLabel.default, {
    className: labelClasses
  }, label), text && _react.default.createElement(_Small.default, {
    className: "m-top-2"
  }, text));
}

TimelineMonth.displayName = 'TimelineMonth';
TimelineMonth.propTypes = {
  isFirstMonth: _propTypes.default.bool,
  label: _propTypes.default.string,
  text: _propTypes.default.string
};
var _default = TimelineMonth;
exports.default = _default;
module.exports = exports.default;